import api from './api';

/**
 * Extension Distribution API Service
 * Handles extension version checking and admin cache management
 */

export const extensionService = {
    /**
     * Get latest extension version information
     * @returns {Promise<Object>} Latest version metadata
     */
    async getLatestVersion() {
        const response = await api.get('/extension/latest-version');
        return response.data;
    },

    /**
     * Check if update is available for current version
     * @param {string} currentVersion - Current installed version (e.g., "1.0.0")
     * @returns {Promise<Object>} Update check result
     */
    async checkForUpdates(currentVersion) {
        const response = await api.get('/extension/update-check', {
            params: { current_version: currentVersion }
        });
        return response.data;
    },

    /**
     * Get release notes for specific version
     * @param {string} version - Version to get notes for
     * @returns {Promise<Object>} Release notes
     */
    async getReleaseNotes(version) {
        const response = await api.get(`/extension/release-notes/${version}`);
        return response.data;
    },

    /**
     * ADMIN: Force refresh of extension cache from GitHub
     * @returns {Promise<Object>} Cache refresh confirmation
     */
    async refreshCache() {
        const response = await api.post('/admin/extension/refresh-cache');
        return response.data;
    },

    /**
     * ADMIN: Get cache statistics
     * @returns {Promise<Object>} Cache stats
     */
    async getCacheStats() {
        const response = await api.get('/admin/extension/cache-stats');
        return response.data;
    }
};
